/* eslint-disable prettier/prettier */

/*import { configureStore } from "@reduxjs/toolkit";
import dashboardReducer from "./dashboard/dashboardSlice";
import rolesReducers from "./roles/rolesSlice";
import usuariosReducers from "./usuarios/usuariosSlice";
import catalogosReducers from "./catalogos/catalogosSlice";
import solicitudesReducers from "./solicitudes/solicitudesSlice";
import tavReducer from "./tav/tavSlice";
import downloadReducers from "./download/downloadSlice";
export default configureStore({
  reducer: {
    dashboard: dashboardReducer,
    roles: rolesReducers,
    usuarios: usuariosReducers,
    catalogos: catalogosReducers,
    solicitud: solicitudesReducers,
    tav: tavReducer,
    download: downloadReducers,
  },
});*/

// store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // usa localStorage

import dashboardReducer from "./dashboard/dashboardSlice";
import rolesReducers from "./roles/rolesSlice";
import usuariosReducers from "./usuarios/usuariosSlice";
import catalogosReducers from "./catalogos/catalogosSlice";
import solicitudesReducers from "./solicitudes/solicitudesSlice";
import tavReducers from "./tav/tavSlice";
import downloadReducers from "./download/downloadSlice";
import loginReducers from "./login/loginSlice";
import galeriaReducers from "./galeria/galeriaSlice";
// Combina todos los reducers
const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  roles: rolesReducers,
  usuarios: usuariosReducers,
  catalogos: catalogosReducers,
  solicitud: solicitudesReducers,
  tav: tavReducers,
  download: downloadReducers,
  login: loginReducers,
  galeria: galeriaReducers,
});

// Configuración de persistencia
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["login"], // solo estos reducers se persisten
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Crear store con reducer persistido
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // requerido para redux-persist
    }),
});

const persistor = persistStore(store);
const login = store.getState().login;

export { store, persistor };
